var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete-custom',{attrs:{"aria-label":_vm.label,"items":_vm.items,"prefix":_vm.prefix,"value":_vm.selectedItem,"clearable":_vm.clearable},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }